import { ProductListingData } from "~/common/ProductDataListing/ListingDisplay";

export interface CartProduct extends ProductListingData {
  unitOfMeasure: string;
  altText: string;
  childLineItems: CartProduct[];
  prop65Message: string;
  shouldItemEstimateDeliveryDate: boolean;
  shouldDisplayDropShipEta: boolean;
  estimatedShipTimeMessage: string;
  itemRibbons: ItemRibbons;
  autoReorderDetails: AutoReorderDetails;
  itemType: ItemType;
  perishableType: string;
  itemNumberId: number;
  parentName?: string;
}

export enum ItemType {
  none = 0,
  base = 1,
  baseParent = 2,
  quoteParent = 3,
  intangibleChild = 4,
  quoteChild = 5,
  baseChild = 6,
  intangibleQuoteChild = 7,
}

interface ItemRibbons {
  showCommonCarrierRibbon: boolean;
  showDeliveryDateRibbon: boolean;
  showSpecialOrderRibbon: boolean;
  hideRibbon: boolean;
  deliveryDateRibbonText: string;
  webPlusShipping: CartProductWebPlusShipping;
  minBuyViewModel?: MinBuyRibbonViewModel;
}

interface AutoReorderDetails {
  autoReorderIntervalId?: number;
  isStagedAutoReorderItem: boolean;
  autoReorderAddOnItemDetails?: AutoReorderAddOnItemDetails;
}

export interface AutoReorderAddOnItemDetails {
  itemNumber: string;
  price: number;
  description: string;
  link: string;
}

export interface CartProductWebPlusShipping {
  isCustomerWebPlusEnrolled: boolean;
  isWebPlusEligible: boolean;
  isEligibleForWebPlusCustomer: boolean;
  isShippingFreeForWebPlusCustomer: boolean;
  isCustomerUsingWebPlusBenefits: boolean;
  isIneligibleForWebPlusCustomer: boolean;
  isShippingFreeForIneligibleForWebPlus: boolean;
  isShippingDiscountedForWebPlusCustomer: boolean;
}

export interface MinBuyRibbonViewModel {
  hasInvalidMinBuy: boolean;
  minBuy: number;
  groupingId: number;
}

export const getDropShipEtaFromItem = (item: CartProduct): string => {
  return getDropShipEta(
    item.estimatedShipTimeMessage,
    item.shouldDisplayDropShipEta,
  );
};

export const getDropShipEta = (
  estimatedShipTimeMessage: string,
  shouldDisplayDropShipEta: boolean,
): string => {
  const dropShipEta =
    shouldDisplayDropShipEta &&
    estimatedShipTimeMessage.length > 0 &&
    estimatedShipTimeMessage.toLowerCase().includes("usually ships")
      ? estimatedShipTimeMessage
      : "";
  return dropShipEta;
};
